import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import ScopeModule from "./scope";
import CostModule from "./cost";
import ScheduleModule from "./schedule";
import AddDeliverableModule from "./addDeliverable";
import EditDeliverableModule from "./editDeliverable";
import AddMilestoneModule from "./addMilestone";
import EditMilestoneModule from "./editMilestone";
import AddResources from "./addResources";
import RemoveResources from "./removeresources";
import { ChangeRequestModule } from "../../../constants/Module";
import { Action } from "../../../constants/Common";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { withTranslation } from "react-i18next";

const ChangeRequestAccordion = (props) => {
  const [expandedModule, setExpandedModule] = useState({});
  const [changeRequestModules, setChangeRequestModules] = useState([]);

  useEffect(() => {
    let projectIndex = 0;
    props.changeRequestDetails.forEach((item, i) => {
      switch (item.module) {
        case ChangeRequestModule.PROJECT: {
          const payloadKeys = Object.keys(item.displayPayload);
          payloadKeys.forEach((_key) => {
            switch (_key) {
              case "scope": {
                setChangeRequestModules((prevState) => {
                  return [
                    ...prevState,
                    {
                      id: ++projectIndex + i,
                      moduleName: props.t("Scope"),
                      moduleDescription: (
                        <ScopeModule scope={item.displayPayload.scope} />
                      ),
                    },
                  ];
                });
                break;
              }
              case "projectCost": {
                setChangeRequestModules((prevState) => {
                  return [
                    ...prevState,
                    {
                      id: ++projectIndex + i,
                      moduleName: props.t("Cost"),
                      moduleDescription: (
                        <CostModule
                          projectCost={item.displayPayload.projectCost}
                        />
                      ),
                    },
                  ];
                });
                break;
              }
              case "schedule": {
                setChangeRequestModules((prevState) => {
                  return [
                    ...prevState,
                    {
                      id: ++projectIndex + i,
                      moduleName: props.t("Schedule"),
                      moduleDescription: (
                        <ScheduleModule
                          schedule={item.displayPayload.schedule}
                          project={
                            {
                            startDate:props.project?.startDate,
                             endDate:props.project?.endDate
                            }
                          }
                        />
                      ),
                    },
                  ];
                });
                break;
              }
              default:
                break;
            }
          });

          break;
        }
        case ChangeRequestModule.MILESTONE: {
          if (item.event === Action.CREATE) {
            setChangeRequestModules((prevState) => {
              return [
                ...prevState,
                {
                  id: (projectIndex > 0 ? projectIndex : 1) + i,
                  moduleName: props.t("Add Milestones"),
                  moduleDescription: (
                    <AddMilestoneModule milestones={item.displayPayload} />
                  ),
                },
              ];
            });
          } else if (item.event === Action.UPDATE) {
            setChangeRequestModules((prevState) => {
              return [
                ...prevState,
                {
                  id: (projectIndex > 0 ? projectIndex : 1) + i,
                  moduleName: props.t("Edit Milestones"),
                  moduleDescription: (
                    <EditMilestoneModule milestones={item.displayPayload} />
                  ),
                },
              ];
            });
          }

          break;
        }
        case ChangeRequestModule.DELIVERABLE: {
          if (item.event === Action.CREATE) {
            setChangeRequestModules((prevState) => {
              return [
                ...prevState,
                {
                  id: (projectIndex > 0 ? projectIndex : 1) + i,
                  moduleName: props.t("Add Deliverables"),
                  moduleDescription: (
                    <AddDeliverableModule deliverable={item.displayPayload} />
                  ),
                },
              ];
            });
          } else if (item.event === Action.UPDATE) {
            setChangeRequestModules((prevState) => {
              return [
                ...prevState,
                {
                  id: (projectIndex > 0 ? projectIndex : 1) + i,
                  moduleName: props.t("Edit Deliverables"),
                  moduleDescription: (
                    <EditDeliverableModule deliverable={item.displayPayload} />
                  ),
                },
              ];
            });
          }

          break;
        }
        case ChangeRequestModule.PROJECT_USER: {
          if (item.event === Action.CREATE) {
            setChangeRequestModules((prevState) => {
              return [
                ...prevState,
                {
                  id: (projectIndex > 0 ? projectIndex : 1) + i,
                  moduleName: props.t("Add Resources"),
                  moduleDescription: (
                    <AddResources teamMembers={item.displayPayload.users} />
                  ),
                },
              ];
            });
          } else if (item.event === Action.DELETE) {
            setChangeRequestModules((prevState) => {
              return [
                ...prevState,
                {
                  id: (projectIndex > 0 ? projectIndex : 1) + i,
                  moduleName: props.t("Remove Resources"),
                  moduleDescription: (
                    <RemoveResources teamMembers={item.displayPayload.users} />
                  ),
                },
              ];
            });
          }

          break;
        }
        default:
          break;
      }
    });
  }, []);

  return (
    <div>
      {changeRequestModules.map((item, index) => (
        <Accordion
          key={item.id}
          expanded={expandedModule[item.id]}
          slotProps={{
            transition: { unmountOnExit: true, mountOnEnter: true },
          }}
        >
          <AccordionSummary
            sx={{
              // pointerEvents: "none",
              "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                transform: "rotate(0deg)",
              },
            }}
            expandIcon={<ExpandMoreIcon sx={{ pointerEvents: "auto" }} />}
          >
            <div className="d-flex justify-content-between w-100">
              <div className="moduleDetail d-flex align-items-center">
                <div className="moduleId">{props.t(item.id)}.</div>&nbsp;
                <span> {item.moduleName}</span>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails className="p-3 bg-white">
            <div className="moduleContent">
              <div className="moduleDesc">{item.moduleDescription}</div>
            </div>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}

export default withTranslation() (ChangeRequestAccordion)